const orderingRoutes = {
  ordering: 'ordering',
  containers: {
    scan: 'scan',
    menu: 'menu',
    category: 'category',
    restaurant: 'restaurant',
    locations: 'locations',
    helpSupport: 'help-support',
    aboutOutlet: 'about-outlet',
    aboutUs: 'about-us',
    cart: 'cart',
    confirmation: 'confirmation',
    payment: 'payment',
    orders: 'orders',
    account: 'account',
    welcome: 'welcome',
    offers: 'offers',
    search: 'search',
    menuOffer: 'menu-offer',
    rewardList: 'list',
    menuItemOffer: 'menu-item-offer',
    rewardProgramDetails: 'program-details',
    referral: 'referral',
    vipMembershipList: 'membership-list',
    vipPassList: 'pass-list',
    vipPassListGetPass: 'pass-list/get-pass',
    sharedPassListView: 'get-pass',
    vipPassDetail: 'pass-detail',
    myRewards: 'my-rewards',
    permissionsAndPrivacy: 'permissions-and-privacy',
  },
  offers: {
    offerList: 'list',
    availOffer: 'avail-offer',
  },
};

export default orderingRoutes;
